module.exports = __webpack_public_path__ + "static/img/KF-logo-white.1e276b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/KF-logo-white.png
// module id = 337
// module chunks = 1